// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2UKPA","content":"RecentSearches_content__83J7-"};